import React, { Component } from 'react';
import { connect } from 'react-redux';


class Loading extends Component {
  render() {
    return (
      <div className="max vpadd30">
        <div className="tac w5 fs18 pbottom20">
          {this.props.title?this.props.title:"Loading..."}
        </div>
        <div className="bubblingG">
	        <span id="bubblingG_1" />
          <span id="bubblingG_2" />
          <span id="bubblingG_3" />
        </div>
      </div>
    )
  }
}


export default Loading;